<template>
  <v-app-bar color="white" height="120px" elevate-on-scroll tile app>
    <v-container class="py-0 container-large">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <div class="d-flex align-center">
          <router-link to="/">
            <img
              v-if="informations.img"
              class="d-block"
              :src="files + informations.img"
              :alt="informations.name"
              height="70px"
            />
          </router-link>

          <div
            v-if="informations.img_faculty || informations.img_foundation"
            class="d-flex flex-column ml-6"
          >
            <v-card
              v-if="informations.img_faculty"
              v-bind="getLinkAttrs(externalLinks.college_website)"
              flat
              tile
            >
              <img
                class="d-block"
                :src="files + informations.img_faculty"
                width="128px"
              />
            </v-card>

            <v-card
              v-if="informations.img_foundation"
              :class="{ 'mt-3': informations.img_faculty }"
              v-bind="getLinkAttrs(externalLinks.foundation_website)"
              flat
              tile
            >
              <img
                class="d-block"
                :src="files + informations.img_foundation"
                width="128px"
              />
            </v-card>
          </div>
        </div>

        <div class="d-flex align-center">
          <div>
            <div
              v-for="({ text, to, dropdown }, keyMenu) in menu"
              :key="keyMenu"
              class="d-inline-flex"
            >
              <v-btn
                v-if="!dropdown"
                class="
                  text-caption text-lg-body-1 text-none
                  font-weight-medium
                  px-2 px-lg-3
                  py-5
                  nav-link
                "
                v-bind="getLinkAttrs(to)"
                active-class="nav-link-active"
                depressed
                tile
                text
              >
                {{ text }}
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="
                      text-caption text-xl-body-2 text-none text-uppercase
                      font-weight-medium
                      px-2
                      py-5
                      mx-xl-2
                      nav-link
                    "
                    color="primary"
                    active-class="nav-link-active"
                    depressed
                    tile
                    text
                  >
                    {{ text }}

                    <v-icon class="ml-1 ml-xl-2" color="primary" size="12">
                      fa-chevron-down
                    </v-icon>
                  </v-btn>
                </template>

                <v-list color="primary" tile>
                  <v-list-item
                    v-for="(item, keyDropdown) in dropdown"
                    :key="keyDropdown"
                    v-bind="getLinkAttrs(item.to)"
                  >
                    <v-list-item-title
                      class="white--text text-body-2 font-weight-medium"
                    >
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { menu } from "../../../config";
import { getLinkAttrs } from "../../../utils/getLinkAttrs";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    externalLinks() {
      return this.$rest("external-links").item;
    },
  },
  methods: {
    getLinkAttrs,
  },
  mixins: [menu],
};
</script>

<style lang="scss" scoped>
.nav-link {
  &:before {
    opacity: 0 !important;
  }
}
</style>
